<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">差し戻し理由入力</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title">商品案内用商品名</label>
            <div class="list-input-content">
              <input type="text" id="lbl_GuideGoodsName" #lbl_GuideGoodsName value="{{kymw1706Model.guideGoodsName}}"
                [style.width.rem]="36" readonly>
            </div>
            <label class="list-input-title">商品案内用規格名</label>
            <div class="list-input-content">
              <input type="text" id="lbl_GuideStandardName" #lbl_GuideStandardName
                value="{{kymw1706Model.guideStandardName}}" [style.width.rem]="20" readonly>
            </div>
            <label class="list-input-title">画像ファイル名</label>
            <div class="list-input-content">
              <input type="text" id="lbl_ImageFileName" #lbl_ImageFileName value="{{kymw1706Model.imageFileName}}"
                [style.width.rem]="12" readonly>
            </div>
            <label class="list-input-title">差し戻し理由</label>
            <div class="list-input-content">
              <app-not-null-text-area id="txta_RemandReason" #txta_RemandReason [subid]="'txta_RemandReason'"
                [allowMultiLine]="true" [maxChars]="200" [style.height.rem]="11" [width]="'100%'"
                [restrict]="'[ -￮\n]'" [displayCountField]="true" [tabindex]="0"></app-not-null-text-area>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Update" class="btn-primary" (click)="eventClickHandler_Remand()" [tabindex]="0">差し戻し</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClickHandler_Close()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>